import { render, staticRenderFns } from "./rewardTrafficPermitLvEdit.vue?vue&type=template&id=1b70cb09&scoped=true&"
import script from "./rewardTrafficPermitLvEdit.vue?vue&type=script&lang=js&"
export * from "./rewardTrafficPermitLvEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b70cb09",
  null
  
)

export default component.exports